import React from 'react';
import { SMALL_RADIUS } from '../../styles/emit-styles/CardStyles';
import { BarChart, Bar, XAxis, YAxis, Legend } from "recharts";
import { filterDataTypes, formatData, getDistanceUnits, getEmissionsUnits } from './UtilityFunctions';
import ReactPDFChart from 'react-pdf-charts';
import { StyleSheet, View, Text } from '@react-pdf/renderer';
import { cardSubtitleStyle, cardTitleStyle, cardTitleWrapperStyle, infoCardStyle } from '../../styles/emit-styles/PdfStylesheet';

const styles = StyleSheet.create({
    infoCard: infoCardStyle,
    cardTitle: cardTitleStyle,
    cardSubtitle: cardSubtitleStyle,
    cardTitleWrapper: cardTitleWrapperStyle
});

const PdfDistributionCard = ({ data, dataTypes, height, width, title, subtitle, dataType, isTd, metricUnitPrefs, macroScale, userSettings }) => {

    const [filteredDataTypes, totalOfData] = filterDataTypes(data, dataTypes);

    let legendFontSize = null;
    if (filteredDataTypes.length >= 5) {
        legendFontSize = 6
    } else if (filteredDataTypes.length >= 4) {
        legendFontSize = 7;
    } else {
        legendFontSize = 8;
    }
    // TODO: Improve this simplistic solution which attemps to prevent the legend from overflowing.
    // Reduce the font size by half a point if displaying emissions in micro scale, or displaying distance
    if ((!macroScale && dataType.includes('Emissions')) || dataType.includes('Distance')) {
        legendFontSize -= 0.5;
    }

    const customLegend = (entry) => {
        const { label } = entry;
        let count = data[0][entry.id]
        let formattedValue = null;
        let formattedLabel = null;

        if (dataType === "allVehicles" || dataType === "altFuelVehicles") {
            formattedValue = count;
        } else if (dataType === "generatedEmissions" || dataType === "avoidedEmissions") {
            formattedValue = formatData('ghg', count, userSettings);
            formattedLabel = ` ${getEmissionsUnits('ghg', metricUnitPrefs.emissions, macroScale, true)}`;          
        } else if (dataType === "simplifiedDistance" || dataType === "allDistance" || dataType === "altFuelDistance") {
            if(!isTd) {
                const percentage = Math.round((count / totalOfData) * 1000) / 10 || "<1"; // if rounded value comes out to 0, display less than 1 %
                formattedValue = percentage
                formattedLabel = '%';
            } else {
                formattedValue = formatData('distance', count, userSettings);
                formattedLabel = ` ${getDistanceUnits(metricUnitPrefs.distance, true, count)}`;
            }
        };
        return `${label} \n (${formattedValue}${formattedLabel ? `${formattedLabel}` : ''})`
    }

    const legendTextFormatter = (value) => {
        return (
            <span style={{ fontSize: legendFontSize }}>{value}</span>
        )
    }

    return (
        <View
            style={[styles.infoCard, { width: width, height: height }]}
        >
            <Text style={styles.cardTitleWrapper}>
                <Text style={styles.cardTitle}>{title}</Text> <Text style={styles.cardSubtitle}>{subtitle}</Text>
            </Text>
            <ReactPDFChart>
                <BarChart
                    width={width - 23} // I don't understand why 23 works exactly, but this ensures the bar takes up the full width of the card. Proabbly will need to be tweaked if padding on the info cards is ever adjusted.
                    height={15} // If this is set any higher the bar starts thinking he's somebody.
                    data={data}
                    layout='vertical'
                    margin={{ left: 0, top: 0, right: 0, bottom: 0 }}
                >
                    <XAxis
                        type='number'
                        domain={0} // ensure that the bars take the full width available to them
                        hide // don't show ticks
                    />
                    <YAxis
                        dataKey="breakdown"
                        type="category"
                        hide // don't show ticks
                    />
                    {filteredDataTypes.map((entry, index) => {
                        const elementCount = filteredDataTypes.length;
                        return (<Bar
                            isAnimationActive={false}
                            key={index}
                            dataKey={entry.id}
                            fill={entry.color}
                            radius={_calculateRadius(index, elementCount)}
                            name={customLegend(entry)}
                            stackId={0}
                            barSize={6}
                        />)
                    })}
                    <Legend
                        iconType='circle'
                        iconSize={8}
                        formatter={legendTextFormatter}
                    />
                </BarChart>
            </ReactPDFChart>
        </View>
    );
};

export default PdfDistributionCard;

const _calculateRadius = (index, elementCount) => {
    const r = SMALL_RADIUS;
    const lastIndex = elementCount - 1;
    let radiusArray = 0
    if (index === 0 && elementCount === 1) radiusArray = [r, r, r, r];
    else if (index === 0 && elementCount > 1) radiusArray = [r, 0, 0, r];
    else if (index === lastIndex) radiusArray = [0, r, r, 0];
    return radiusArray;
}